import client from 'src/api/apollo/client';
import { WORTH_UPDATE } from 'src/api/graphql/mutations/worth.gql';
import { createGraphqlRequestError } from 'src/utils/helpers/getGraphqlErrorMessage';

export const updateWorth = async (companyId, input) => {
	try {
		const { data } = await client.mutate({
			mutation: WORTH_UPDATE,
			variables: {
				companyId: String(companyId),
				input,
			},
		});

		return data.WorthUpdate.worth;
	} catch (error) {
		throw createGraphqlRequestError(error, 'Не удалось изменить ценность');
	}
};
